export interface PolicyCheckboxCopy {
  rentalAgreementText: string;
  termsConditionsText: string;
  privacyCancellationText: string;
}

export const DEFAULT_POLICY_CHECKBOX_COPY: PolicyCheckboxCopy = {
  rentalAgreementText:
    "I have read and accept all the rental agreement mentioned below and i verify that all the details mentioned below are correct",
  termsConditionsText:
    "I have read and accept all the terms and conditions mentioned below and i verify that all the details mentioned below are correct",
  privacyCancellationText:
    "I have read and accept all the policy and cancellation policy mentioned in the rental agreement and i verify that all the details mentioned in the agreement are correct",
};

const getValueFromPath = (obj: any, path: string) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc: any, key: string) => acc?.[key], obj);
};

const hasMeaningfulText = (value: any) => {
  if (typeof value !== "string") return false;
  const withoutTags = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
  return withoutTags.length > 0;
};

const getFirstValidString = (source: any, paths: string[], fallback: string) => {
  for (const path of paths) {
    const value = getValueFromPath(source, path);
    if (hasMeaningfulText(value)) {
      return value;
    }
  }
  return fallback;
};

export const resolvePolicyCheckboxCopy = (companyDetails: any): PolicyCheckboxCopy => {
  const source = companyDetails ?? {};

  return {
    rentalAgreementText: getFirstValidString(
      source,
      [
        "rental_agreement_text",
        "rental_agreement_checkbox_text",
        "terms_checkbox_content.rental_agreement_text",
        "policies.rental_agreement_text",
        "policies.checkbox.rental_agreement_text",
      ],
      DEFAULT_POLICY_CHECKBOX_COPY.rentalAgreementText,
    ),
    termsConditionsText: getFirstValidString(
      source,
      [
        "terms_conditions_text",
        "terms_and_conditions_text",
        "terms_conditions_checkbox_text",
        "terms_checkbox_content.terms_conditions_text",
        "policies.terms_conditions_text",
        "policies.checkbox.terms_conditions_text",
      ],
      DEFAULT_POLICY_CHECKBOX_COPY.termsConditionsText,
    ),
    privacyCancellationText: getFirstValidString(
      source,
      [
        "privacy_cancellation_policy_text",
        "privacy_policy_cancellation_policy_text",
        "privacy_cancellation_checkbox_text",
        "terms_checkbox_content.privacy_cancellation_policy_text",
        "policies.privacy_cancellation_policy_text",
        "policies.checkbox.privacy_cancellation_policy_text",
      ],
      DEFAULT_POLICY_CHECKBOX_COPY.privacyCancellationText,
    ),
  };
};
